import { uniqueId } from "@/views/zhiji/js/common/util.js";

export default {
    widgetName: "RoleMessage",
    serverType: "roleMessage",
    initContent() {
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "RoleMessage",
            roleData: initRoleData()
        };
    },
    checkContent() {},
    // 后台数据转前端数据
    server2Client(content) {
        return {
            uId: uniqueId(),
            wtType: "RoleMessage",
            updateState: "",
            roleData: content.roleData
        };
    },
    // 前端数据转后台数据
    client2Server(content) {
        return {
            type: "roleMessage",
            roleData: content.roleData
        };
    }
};

function initRoleData() {
    return [
        {
            num: "1",
            title: "iPlatform",
            type: "dropMenu",
            name: "platform", //默认控件
            is_need: true, //是否必填
            tip: "", //备注
            readonly: false, //false可编辑，true只读
            options: [
                {
                    label: "ios",
                    value: "ios",
                    link_option: "",
                    selected: false
                },
                {
                    label: "android",
                    value: "android",
                    link_option: "",
                    selected: false
                }
            ]
        },
        {
            num: "2",
            title: "iChannel",
            type: "dropMenu",
            name: "channel", //默认控件
            is_need: true, //是否必填
            tip: "", //备注
            readonly: false, //false可编辑，true只读
            options: [
                {
                    label: "facebook",
                    value: "facebook",
                    link_option: "",
                    selected: false
                },
                {
                    label: "apple",
                    value: "apple",
                    link_option: "",
                    selected: false
                },
                {
                    label: "google",
                    value: "google",
                    link_option: "",
                    selected: false
                },
                {
                    label: "guest",
                    value: "guest",
                    link_option: "",
                    selected: false
                }
            ]
        },
        {
            num: "3",
            title: "email",
            type: "text",
            name: "email",
            is_need: true,
            tip: "",
            value: "",
            verify: "",
            readonly: false
        },
        {
            num: "4",
            title: "role_name",
            type: "text",
            name: "role_name",
            is_need: true,
            tip: "",
            value: "",
            verify: "",
            readonly: false
        }
    ];
}
